export const FETCH_MY_COLLECTIONS_REQUEST = 'FETCH_MY_COLLECTIONS_REQUEST';
export const FETCH_MY_COLLECTIONS_SUCCESS = 'FETCH_MY_COLLECTIONS_SUCCESS';
export const FETCH_MY_COLLECTIONS_FAILURE = 'FETCH_MY_COLLECTIONS_FAILURE';

export const FETCH_ALL_BRANDS_REQUEST = 'FETCH_ALL_BRANDS_REQUEST';
export const FETCH_ALL_BRANDS_SUCCESS = 'FETCH_ALL_BRANDS_SUCCESS';
export const FETCH_ALL_BRANDS_FAILURE = 'FETCH_ALL_BRANDS_FAILURE';

export const FETCH_REQUESTED_BY_REQUEST = 'FETCH_REQUESTED_BY_REQUEST';
export const FETCH_REQUESTED_BY_SUCCESS = 'FETCH_REQUESTED_BY_SUCCESS';
export const FETCH_REQUESTED_BY_FAILURE = 'FETCH_REQUESTED_BY_FAILURE';

export const FETCH_RECOSTING_REQUEST = 'FETCH_RECOSTING_REQUEST';
export const FETCH_RECOSTING_SUCCESS = 'FETCH_RECOSTING_SUCCESS';
export const FETCH_RECOSTING_FAILURE = 'FETCH_REQUESTED_BY_FAILURE';

export const FETCH_MORE_RECOSTING_REQUEST = 'FETCH_MORE_RECOSTING_REQUEST';
export const FETCH_MORE_RECOSTING_SUCCESS = 'FETCH_MORE_RECOSTING_SUCCESS';
export const FETCH_MORE_RECOSTING_FAILURE = 'FETCH_MORE_REQUESTED_BY_FAILURE';
